<template>
  <li class="group relative flex items-start gap-8 pb-16">
    <div
      v-if="!isLast"
      class="absolute left-8 top-16 w-1 h-full bg-gradient-to-b from-secondary/20 via-primary/30 to-success/20 rounded-full"></div>

    <div class="relative flex-shrink-0 z-20">
      <div
        class="relative w-16 h-16 sm:w-20 sm:h-20 rounded-full flex items-center justify-center text-white shadow-lg ring-4 ring-white/80 backdrop-blur-sm transform group-hover:scale-110 transition-all duration-300 z-10"
        :class="gradientClass">
        <component :is="step.icon || DefaultIcon" class="w-8 h-8 sm:w-10 sm:h-10" />
      </div>
    </div>

    <div class="flex-1 relative">
      <div
        class="group relative bg-white border border-base-200 shadow-lg hover:shadow-xl rounded-2xl p-8 transition-all duration-300 h-full">
        <div
          class="absolute inset-0 bg-gradient-to-br from-primary/3 via-transparent to-success/3 rounded-2xl pointer-events-none"></div>

        <div class="relative z-10">
          <h3 class="text-2xl sm:text-3xl lg:text-4xl font-bold mb-4 leading-tight text-base-content">
            {{ step.title }}
          </h3>

          <p class="text-lg sm:text-xl text-base-content/80 leading-relaxed mb-6">
            {{ step.desc }}
          </p>

          <div
            class="inline-flex items-center gap-2 bg-gradient-to-r from-success/10 to-primary/10 border border-success/20 rounded-full px-4 py-2 mb-6">
            <div class="w-2 h-2 bg-gradient-to-r from-success to-primary rounded-full"></div>
            <LucideTimer class="w-5 h-5 text-success" />
            <span class="text-success font-semibold text-sm">{{ step.duration }}</span>
          </div>
        </div>
      </div>
    </div>
  </li>
</template>

<script setup lang="ts">
import { LucideTimer, LucideCheckCircle } from "lucide-vue-next";
import type { Component } from "vue";

const props = defineProps<{
  step: { title: string; desc: string; duration: string; quote?: string; emotionalBenefit?: string; icon?: Component };
  index: number;
  isLast?: boolean;
}>();

const DefaultIcon = LucideCheckCircle;

const gradientClass = [
  "bg-gradient-to-br from-purple-500 to-pink-500",
  "bg-gradient-to-br from-blue-500 to-cyan-500",
  "bg-gradient-to-br from-green-500 to-teal-500",
  "bg-gradient-to-br from-yellow-500 to-orange-500",
  "bg-gradient-to-br from-rose-500 to-red-500",
][props.index % 5];
</script>

<style scoped></style>
